
export default function About() {
  const stats = [
    { number: '15+', label: 'Years Team Experience' },
    { number: '500+', label: 'Qualified Suppliers' },
    { number: '30%', label: 'Average Cost Reduction' }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/46a8103984d83d0ac0403974fba1cc52.jpg"
                alt="Our Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <span className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Us
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Your External Procurement Team
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed mb-8">
              <p>
                Inter-American Procurement Group serves as your dedicated external procurement partner, specializing in helping U.S. companies navigate the complexities of Latin American sourcing. We combine deep regional expertise with proven procurement strategies to deliver measurable cost savings and operational improvements.
              </p>
              <p>
                Our team brings decades of combined experience in supplier management, contract negotiation, and logistics optimization across Latin America. We understand the unique challenges of cross-border procurement and have built a network of qualified suppliers ready to meet your specific requirements.
              </p>
              <p>
                By partnering with us, you gain access to our extensive supplier network, market intelligence, and procurement expertise—allowing you to focus on your core business while we manage the complexities of your Latin American supply chain.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl font-bold text-orange-600 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
